import { useIntl } from 'react-intl';
import core, { View } from '@gin-betting/core';
import dFnsIsTomorrow from 'date-fns/isTomorrow';
import parseISO from 'date-fns/parseISO';

import { LIVE_SPORTEVENT_STATUSES } from 'app-constants';
import { useMatchTime } from 'hooks';
import globalMsgs from 'messages';

const {
    utils: { formatTimeAndDate },
} = core;

interface Input {
    sportEvent: View.Match;
    withDate: boolean;
}

interface Output {
    text: string | null;
    subText: string | null;
}

export default function useFixtureData({
    sportEvent,
    withDate,
}: Input): Output {
    const { formatMessage } = useIntl();
    const { currentMatchPart, matchTimeToShow } = useMatchTime({
        matchId: sportEvent.id,
    });

    const { startTime, status } = sportEvent;

    const isLive = LIVE_SPORTEVENT_STATUSES.includes(status);

    if (!withDate) {
        return {
            text: null,
            subText: null,
        };
    }

    if (isLive) {
        return {
            text: currentMatchPart || '',
            subText: matchTimeToShow,
        };
    }

    const { date, time, isToday } = formatTimeAndDate(startTime, {
        // => 01.10 / Oct 01
        // dateFormat: isSmall ? 'dd.MM' : 'MMM dd',
        dateFormat: 'MMM dd',
    });

    const isTomorrow = dFnsIsTomorrow(parseISO(startTime));

    return {
        text: time,
        subText: isToday
            ? formatMessage(globalMsgs.todayText)
            : isTomorrow
            ? formatMessage(globalMsgs.tomorrowText)
            : date,
    };
}
